export const CREDITS_REQUEST = "API/ENTITIES/CREDITS_REQUEST";
export const CREDITS_REQUEST_FAILURE = "API/ENTITIES/CREDITS_REQUEST_FAILURE";
export const CREDITS_REQUEST_SUCCESS = "API/ENTITIES/CREDITS_REQUEST_SUCCESS";
